//*Libraries imports
import { useState, useEffect } from "react";

//*Components Imports
import { CircularProgress } from "@material-ui/core";
import { Modal, Button, Tab, Tabs } from "react-bootstrap";
import { STORAGE_URL } from "../../../variables";

//*Manager Imports
import InscricoesCriteriosAssinaturasManager from "../InscricoesCriteriosAssinaturasManager";
import { useSelector } from "react-redux";

function SignatureViewModal({
  show,
  handleClose,
  data,
  loading,
  selectionKey,
}) {
  const [key, setKey] = useState("1");
  const [downloading, setDownloading] = useState(false);
  const user = useSelector(store=>store.AppReducer.user);

  const [imagesLoading, setImagesLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setImagesLoading(true);
      const imagesToLoad = [];
      for (let i = 1; i <= 3; i++) {
        if (data[`caminho_arquivo_assinatura_${i}`]) {
          imagesToLoad.push(
            STORAGE_URL + data[`caminho_arquivo_assinatura_${i}`],
          );
        }
        if (data[`caminho_arquivo_carimbo_${i}`]) {
          imagesToLoad.push(STORAGE_URL + data[`caminho_arquivo_carimbo_${i}`]);
        }
      }

      if (imagesToLoad.length === 0) {
        setImagesLoading(false);
        return;
      }

      let loadedCount = 0;
      const checkDone = () => {
        loadedCount++;
        if (loadedCount === imagesToLoad.length) {
          setImagesLoading(false);
        }
      };

      imagesToLoad.forEach((src) => {
        const img = new Image();
        img.onload = checkDone;
        img.onerror = checkDone;
        img.src = src;
      });
    }
  }, [data]);

  const openTestCertificate = async () => {
    setDownloading(true);
    try {
      const blob =
        await InscricoesCriteriosAssinaturasManager.DownloadTestCertificate(
          selectionKey,
        );
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `teste_certificado_${selectionKey}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        alert("Erro ao baixar o certificado de teste.");
      }
    } catch (e) {
      console.error(e);
      alert("Erro ao baixar o certificado.");
    } finally {
      setDownloading(false);
    }
  };

  const renderTab = (index) => {
    const sigPath = data?.[`caminho_arquivo_assinatura_${index}`];
    const stampPath = data?.[`caminho_arquivo_carimbo_${index}`];

    return (
      <div className="p-3 text-center d-flex flex-column align-items-center gap-2">
        <h6>Assinatura {index}</h6>
        {sigPath ? (
          <img
            src={STORAGE_URL + sigPath}
            alt={`Assinatura ${index}`}
            style={{ maxHeight: 100, maxWidth: "100%" }}
            className="pb-3 border rounded p-1"
          />
        ) : (
          <p className="text-muted small">Não cadastrada</p>
        )}

        <hr className="w-100" />

        <h6>Carimbo {index}</h6>
        {stampPath ? (
          <img
            src={STORAGE_URL + stampPath}
            alt={`Carimbo ${index}`}
            style={{ maxHeight: 100, maxWidth: "100%" }}
            className="pb-3 border rounded p-1"
          />
        ) : (
          <p className="text-muted small">Não cadastrado</p>
        )}
      </div>
    );
  };

  const renderTabNumber = ()=>{
    console.log(user);
    if(user.email=='gislaina.sleal@adm.educacao.pe.gov.br'){
      return [1];
    }
    else if(user.email=='izabel.cprocha@adm.educacao.pe.gov.br'){
      return [2];
    }
    else if(user.email=='ana.elizabete1962@adm.educacao.pe.gov.br'){
      return [3];
    }

    return [1, 2, 3];
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Visualizar Assinaturas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading || imagesLoading ? (
          <div className="text-center py-5">
            <CircularProgress />
          </div>
        ) : (
          <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="pb-3">
            {renderTabNumber().map((i) => (
              <Tab key={i} eventKey={`${i}`} title={`Assinatura ${i}`}>
                {renderTab(i)}
              </Tab>
            ))}
          </Tabs>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="info"
          onClick={openTestCertificate}
          disabled={loading || downloading}
        >
          {downloading ? (
            <span className="d-flex align-items-center gap-2">
              <CircularProgress size={16} color="inherit" />
              Baixando...
            </span>
          ) : (
            "Visualizar Certificado de Teste"
          )}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SignatureViewModal;
